export * from './BarChartComponent';
